import {
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { Company } from "../../models/company";
import { User } from "../../models/user";
import { Events, Nav, NavController, App } from "ionic-angular";

import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
import * as companyActions from "../../actions/company.actions";
import * as comparisonActions from "../../actions/comparison.actions";
import * as users from "../../actions/user.actions";
import { Api } from "../../providers/api/api";
import { Subscription } from "rxjs";

@Component({
  selector: "company-side-bar",
  templateUrl: "company-side-bar.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanySideBarComponent {
  @Input() company: Company;
  @Input() user: User;
  @Input() showCashflow: boolean;

  filter: any;
  filtersSubscription: any = null;
  u: any;
  userSubscription: any = null;
  allFilters: any;
  universeCompany: any;
  universeSubscription?: Subscription;

  constructor(
    protected app: App,
    private api: Api,
    private changeDetectorRef: ChangeDetectorRef,
    public store: Store<fromRoot.State>,
    public eventsCtrl: Events
  ) {
    this.allFilters = this.store.select(fromRoot.getFilters);
  }

  get navCtrl(): NavController {
    return this.app.getRootNav();
  }

  ngOnInit() {
    this.subscribeToStores();
    this.getUniverseCompany();
    this.universeSubscription = this.store.select(fromRoot.getUniverse).subscribe((u) => {
      this.getUniverseCompany()
    });
  }

  ngOnDestroy() {
    if (this.filtersSubscription !== null)
      this.filtersSubscription.unsubscribe();
    if (this.userSubscription !== null) this.userSubscription.unsubscribe();
    if (this.universeCompany) this.universeSubscription.unsubscribe();
  }

  ngOnChanges(changes) {
    if (!("company" in changes)) {
      return;
    }
    this.universeCompany = undefined;
    if (changes.company.previousValue !== changes.company.currentValue) {
      this.getUniverseCompany();
    }
  }

  getUniverseCompany() {
    if (!this.company) {
      return;
    }
    this.api.getUniverseCompany(this.company.perm_sec_id).subscribe(company => {
      this.universeCompany = company["company"];
      this.changeDetectorRef.markForCheck();
    });
  }

  toggleShowCashflow(event) {
    this.store.dispatch(new companyActions.SetShowCashflow(event.value));
  }

  goComparison(ticker) {
    this.store.dispatch(
      new comparisonActions.FetchCompanyForComparison({ ticker, choice: 0 })
    );
    this.navCtrl.push("CompanyComparisonPage", { ticker });
  }

  subscribeToStores() {
    this.filtersSubscription = this.allFilters.subscribe(filters => {
      //Get the 'All' filter used in the screens page
      let filter = filters.find(f => f.ref === "all");

      if (filter == undefined) {
        return;
      } else {
        this.filter = filter;
      }
    });
  }

  goScreens(params) {
    this.filter.screens = {};
    this.filter.screens.sector = params.sector;
    this.filter.screens.industry = params.industry;
    this.filter.screens.region = params.region;
    this.filter.screens.country = params.country;

    if (!this.filter.screens.sector && isEmpty(this.filter.screens.sector))
      delete this.filter.screens.sector;
    if (!this.filter.screens.industry && isEmpty(this.filter.screens.industry))
      delete this.filter.screens.industry;
    if (!this.filter.screens.region && isEmpty(this.filter.screens.region))
      delete this.filter.screens.region;
    if (!this.filter.screens.country && isEmpty(this.filter.screens.country))
      delete this.filter.screens.country;

    this.eventsCtrl.publish("openPage", "ScreensPage", { filter: this.filter });
    this.store.dispatch(
      new users.UpdateFilter({ user_id: this.user._id, filter: this.filter })
    );
  }
}

function isEmpty(val) {
  let lreturn: boolean;

  if (val == 0) lreturn = false;
  lreturn =
    isNaN(val) || val === undefined || val == null || val.length <= 0
      ? true
      : false;
  return lreturn;
}



// WEBPACK FOOTER //
// ./src/components/company-side-bar/company-side-bar.ts